import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView_三门峡.vue'
import { cityOption } from '@/util/mainOption'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => cityOption.cityName == "三门峡" ? import('../views/HomeView_三门峡.vue') : import('../views/HomeView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news.vue')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('@/views/newsDetail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
